/**
 * Wording of a rental check's verdict — shared by the car's Kontroly modal and the dashboard card, so the same
 * check reads the same everywhere. The API judges (due-ness is computed on read); this only phrases it.
 */

import { formatInt } from '@/lib/format';

/** Czech plural of "den" for a count: "1 den", "3 dny", "12 dní". */
export function dnu(n: number): string {
  return `${formatInt(n)} ${n === 1 ? 'den' : n >= 2 && n <= 4 ? 'dny' : 'dní'}`;
}

export interface KontrolaVerdict {
  zbyva_dni: number | null;
  zbyva_km: number | null;
  odhad_dni: number | null;
}

/** What is left of an open check: the date part and the km part, in words. */
export function remaining(k: KontrolaVerdict): string[] {
  const out: string[] = [];
  if (k.zbyva_dni != null) {
    out.push(k.zbyva_dni < 0 ? `po termínu o ${dnu(-k.zbyva_dni)}` : k.zbyva_dni === 0 ? 'termín je dnes' : `za ${dnu(k.zbyva_dni)}`);
  }
  if (k.zbyva_km != null) {
    out.push(k.zbyva_km < 0 ? `nájezd překročen o ${formatInt(-k.zbyva_km)} km` : k.zbyva_km === 0 ? 'nájezd dosažen' : `zbývá ${formatInt(k.zbyva_km)} km`);
    if (k.zbyva_km > 0 && k.odhad_dni != null) out.push(`při současném tempu cca za ${dnu(k.odhad_dni)}`);
  }
  return out;
}
